<style scoped>
.product-image {
    width: 150px;
}

.product-questions {
    max-width: 800px;
}

.t-coin-fade-enter-active {
    transition: all 0.3s ease;
}
.t-coin-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.t-coin-fade-enter,
.t-coin-fade-leave-to {
    transform: translateY(-300px);
    opacity: 0;
}

.question-container-fade-leave-active {
    transition: opacity 0.3s;
}
.question-container-fade-leave-to {
    opacity: 0;
}

.test {
    position: absolute;
    height: 70%;
    width: 100%;
    top: 50%;
    left: 50%;

    transform: translate(-40%, -50%);
    @apply border-r border-gray-100 border-dotted;
}
</style>

<template>
    <div class="relative" ref="feedback-container">
        <productFeedbackAccountInfoFormModal
            v-if="showInfoModal"
            :prodFdbkEmailTknNum="$route.params.prodFdbkEmailTknNum"
            :custTypeCode="custTypeCode"
            :productFeedbackAccountInfoForm="productFeedbackAccountInfoForm"
            :occupationList="occupationList"
            :jobLevelList="jobLevelList"
            :monthlyIncomeList="monthlyIncomeList"
            :genderCodeList="genderCodeList"
            :showBirthdayTcoinGiftMessage="showBirthdayTcoinGiftMessage"
            @hide="() => $router.push('/')"
            @success="() => (showInfoModal = false)"
        />
        <breadcrumb
            class="mt-4"
            v-if="breadcrumb.show"
            :links="breadcrumb.links"
        />
        <transition v-for="(t, i) in toasts" :key="i" name="t-coin-fade">
            <msgSlot
                :msgKey="'{0} +1'"
                class="inline-flex items-center absolute text-3xl sm:text-5xl text-primary"
                style="z-index: 1;"
                :style="{ bottom: t.bottom + 'px', left: t.left + 'px' }"
            >
                <template #slot0>
                    <div class="icon w-8 h-8 sm:w-16 sm:h-16 text-primary">
                        <tryhalaCoinSvg />
                    </div>
                </template>
            </msgSlot>
        </transition>

        <section class="content-box-wrapper">
            <div>
                <div class="text-xl font-bold">
                    {{ $t('product.feedback') }}
                </div>
                <div class="text-lg mt-4">
                    {{
                        '分享產品體驗能夠免費賺取T-Coins，所以記住回答下⾯既問卷啊！'
                    }}
                </div>
                <div class="text-sm text-red mt-2">
                    {{ '回答每條問題可賺取 1 T-Coin' }}
                </div>
            </div>

            <div class="my-2 sm:my-6">
                <div class="my-8 flex justify-center" v-if="loading">
                    <spinner />
                </div>

                <div v-else>
                    <template v-for="(p, pi) in prodFdbkList">
                        <transition :key="p.id" name="question-container-fade">
                            <div
                                :ref="`ref_${pi}`"
                                :key="p.id"
                                class="flex flex-col sm:flex-row sm:justify-between mb-4 py-2 px-1 sm:px-8"
                            >
                                <div
                                    class="relative self-center sm:self-start flex flex-col flex-shrink-0 items-start product-image sm:mr-8"
                                >
                                    <div class="relative w-full">
                                        <productImage
                                            :product="p"
                                            imageType="small"
                                        />
                                        <div v-if="false" class="test"></div>
                                    </div>

                                    <router-link
                                        :to="{
                                            name: 'productInfo',
                                            params: { prodId: p.prodId }
                                        }"
                                        class="text-secondary text-sm underline cursor-pointer mx-auto mt-2 hover:text-blue"
                                    >
                                        查看產品資訊
                                    </router-link>
                                </div>
                                <div
                                    class="flex flex-col flex-grow product-questions"
                                >
                                    <contentNewLine
                                        class="text-2xl font-bold"
                                        :value="productDisplayFullname(p)"
                                    />

                                    <div>
                                        <div class="text-lg">
                                            {{ '你有多麼喜歡這個產品?' }}
                                        </div>
                                        <buttonFeedback
                                            class="my-4 text-base"
                                            :prodFdbkEmailTknNum="
                                                p.prodFdbkEmailTknNum
                                            "
                                            :slctKey="p.prodRateSlctKey"
                                            @slctKey="
                                                key => (p.prodRateSlctKey = key)
                                            "
                                            :options="prodRateSlctList"
                                            feedbackType="ProductRate"
                                            @submitted="submitted"
                                        />
                                    </div>

                                    <div>
                                        <div class="text-lg">
                                            {{
                                                '你有多願意推薦這個產品給朋友，家⼈和同事？'
                                            }}
                                        </div>
                                        <buttonFeedback
                                            class="my-4 text-base"
                                            :prodFdbkEmailTknNum="
                                                p.prodFdbkEmailTknNum
                                            "
                                            :slctKey="p.prodRcmdSlctKey"
                                            @slctKey="
                                                key => (p.prodRcmdSlctKey = key)
                                            "
                                            :options="prodRateRcmdList"
                                            feedbackType="ProductRecommendation"
                                            @submitted="submitted"
                                        />
                                    </div>
                                </div></div
                        ></transition>
                    </template>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import msgSlot from '@/components/msgSlot';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import productImage from '@/components/productImage.vue';
import buttonFeedback from '@/components/buttonFeedback.vue';
import sortBy from 'lodash/sortBy';
import spinner from '@/components/spinner.vue';
import contentNewLine from '@/components/contentNewLine';
import productFeedbackAccountInfoFormModal from '@/components/productFeedbackAccountInfoFormModal.vue';

export default {
    components: {
        breadcrumb,
        msgSlot,
        tryhalaCoinSvg,
        productImage,
        buttonFeedback,
        spinner,
        contentNewLine,
        productFeedbackAccountInfoFormModal
    },
    data() {
        return {
            showInfoModal: false,
            showTcoinGainMsg: false,
            toasts: [],
            loading: false,
            prodFdbkList: [],
            prodRateSlctList: [],
            prodRateRcmdList: [],
            custTypeCode: undefined,
            productFeedbackAccountInfoForm: {},
            occupationList: [],
            jobLevelList: [],
            monthlyIncomeList: [],
            genderCodeList: [],
            showBirthdayTcoinGiftMessage: false
        };
    },
    computed: {
        breadcrumb() {
            return this.$route.name === 'feedbackByToken'
                ? { show: false, links: [] }
                : { show: true, links: [{ msg: 'product.feedback' }] };
        },
        productDisplayFullname() {
            return product =>
                this.$store.getters.productDisplayFullname(product);
        }
    },
    async created() {
        this.loading = true;
        const prodFdbkReferenceData =
            this.$route.name === 'feedbackByToken'
                ? await this.$store.dispatch(
                      'getProductFeedbacksByToken',
                      this.$route.params.prodFdbkEmailTknNum
                  )
                : await this.$store.dispatch('getProductFeedbacks');
        if (!prodFdbkReferenceData?.prodFdbkList) {
            this.$router.push({ name: 'pageNotFound' });
        }
        this.prodFdbkList = prodFdbkReferenceData.prodFdbkList || [];
        this.prodRateSlctList = sortBy(prodFdbkReferenceData.prodRateSlctList, [
            'slctDispSeqNum'
        ]);
        this.prodRateRcmdList = sortBy(prodFdbkReferenceData.prodRateRcmdList, [
            'slctDispSeqNum'
        ]);

        if (!prodFdbkReferenceData.isProdFdbkReqInfoCompleted) {
            this.custTypeCode = prodFdbkReferenceData.custTypeCode;
            this.productFeedbackAccountInfoForm =
                prodFdbkReferenceData.productFeedbackAccountInfoForm;
            this.occupationList = prodFdbkReferenceData.occupationList;
            this.jobLevelList = prodFdbkReferenceData.jobLevelList;
            this.monthlyIncomeList = prodFdbkReferenceData.monthlyIncomeList;
            this.showBirthdayTcoinGiftMessage =
                prodFdbkReferenceData.showBirthdayTcoinGiftMessage;
            this.genderCodeList = prodFdbkReferenceData.genderCodeList;
            this.showInfoModal = true;
        }
        this.loading = false;
    },
    methods: {
        submitted(domRect) {
            this.$store.commit(
                'setCrdtPntBal',
                this.$store.state.crdtPntBal + 1
            );

            const containerDomRect = this.$refs[
                'feedback-container'
            ].getBoundingClientRect();

            const bottom = containerDomRect.bottom - domRect.top;
            const left = domRect.left - containerDomRect.left;
            const toast = { bottom: bottom, left: left };
            this.toasts.push(toast);
            setTimeout(() => {
                this.toasts = [];
            }, 1000 * 1);

            clearTimeout(this.tcoinGainTimeout);
            clearTimeout(this.removeProdFdbkTimeout);
            this.showTcoinGainMsg = true;
            this.tcoinGainTimeout = setTimeout(() => {
                this.showTcoinGainMsg = false;
            }, 1000 * 1);
            this.removeProdFdbkTimeout = setTimeout(() => {
                this.prodFdbkList = this.prodFdbkList.filter(
                    f => !f.prodRcmdSlctKey || !f.prodRateSlctKey
                );
            }, 1500);
        }
    }
};
</script>
